var map = {
	"./partner_1.png": "0373",
	"./partner_10.png": "5121",
	"./partner_2.png": "ec73",
	"./partner_3.png": "1ca8",
	"./partner_4.png": "ffe3",
	"./partner_5.png": "335f",
	"./partner_6.png": "e5a7",
	"./partner_7.png": "f7d5",
	"./partner_8.png": "48bf",
	"./partner_9.png": "44cd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e2dd";